<template>
  <a class="no-data">
    <img src="./assets/no-data.png" alt="">
    <span class="desc">
      <slot>暂无内容</slot>
    </span>
  </a>
</template>

<script>
export default {
  name: 'noData',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.no-data
{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 150px;
  img
  {
    width: 132px;
  }
  .desc
  {
    margin-top: 16px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/no-data/index.vue